import { Layout } from 'react-admin';
import * as React from 'react';
import LamsAppBar from './LamsAppBar';
import LamsSidebar from './LamsSidebar';
// import MyMenu from './MyMenu';
// import MyNotification from './MyNotification';

const LamsLayout = props => <Layout
    {...props}
    appBar={LamsAppBar}
    sidebar={LamsSidebar}
// menu={MyMenu}
// notification={MyNotification}
/>;

export default LamsLayout;